/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 批量编辑水印会员引导固定展示方案
 */

/** 当前唯一保留的会员引导方案，同时作为历史支付归因的稳定标识。 */
export const ACTIVE_MEMBERSHIP_MODAL_VARIANT = 'product_pitch_v3' as const

export const MEMBERSHIP_MODAL_VARIANTS = [
  ACTIVE_MEMBERSHIP_MODAL_VARIANT
] as const

export type MembershipModalVariant = (typeof MEMBERSHIP_MODAL_VARIANTS)[number]
